export default __webpack_public_path__ + "static/media/custom_fields_intro.203a7d7a.svg";